(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/objectWithoutProperties', 'react', 'react-router-dom', './AuthService'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/objectWithoutProperties'), require('react'), require('react-router-dom'), require('./AuthService'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectWithoutProperties, global.react, global.reactRouterDom, global.AuthService);
    global.ProtectedRoute = mod.exports;
  }
})(this, function (exports, _extends2, _objectWithoutProperties2, _react, _reactRouterDom, _AuthService) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ProtectedRoute = undefined;

  var _extends3 = _interopRequireDefault(_extends2);

  var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

  var _react2 = _interopRequireDefault(_react);

  var _AuthService2 = _interopRequireDefault(_AuthService);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var auth = new _AuthService2.default();

  var ProtectedRoute = function ProtectedRoute(_ref) {
    var Component = _ref.component,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['component']);
    return _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
      render: function render(props) {
        return auth.getStatus().data ? _react2.default.createElement(Component, props) : window.location.replace('https://accounts.peachjar.com:10443/districts/login');
      }
    }));
  };
  exports.ProtectedRoute = ProtectedRoute;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Routing/ProtectedRoute.js
// module id = 864
// module chunks = 1